const project = process.env.REACT_APP_PROJECT;
console.log("PROJECT: " + project);
require("./"+ project);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx